<div id="loader-overlay">
  <div class="loader-component w-100 text-center my-2">
    <fa-icon [icon]="faSpinner" [spin]="true" class="mr-2"></fa-icon>
    <span>{{ text | translate }}</span>
  </div>
</div>
